import { getRequestHash } from '../utils/helpers';
import Service from './abstract';
import loanevents from './loanevents';

export class LoanLogs extends Service {
    constructor () {
        super('cuotitasstores/loanlogs')
        
        this.port = 'WEB02';
        this.method = 'GET';
        
        this.extra = {};
        this.params = {};
        this.query = {};
        this.body = {};

        this.extra.theme = document.getElementById('root').getAttribute('theme');
        this.extra.hash = getRequestHash()
    }

    // point to local cuotitasstores microservice
    // get baseURL() {
    //     return `http://localhost:64055/loanlogs`
    // }

    async success (path, { params, query, body, response } = {}) {
        try {
            if(!this.extra.trace) {
                this.extra.trace = loanevents.trace || await loanevents.findTrace({ hash: this.extra.hash }).catch(() => undefined);
            }

            if(!this.extra.theme) {
                this.extra.theme = document.getElementById('root').getAttribute('theme');
            }
            
            await this.post('/success', {
                body: {
                    path,
                    port: this.port, 
                    method: this.method, 
                    extra: this.extra,
                    params: params || this.params,
                    query: query || this.query,
                    body: body || this.body,
                    response: response || {},
                }
            })
                
        } catch (error) {
            console.error(error)            
        }
    }

    async error (path, error, { params, query, body } = {}) {
        try {
            if(!this.extra.trace) {
                this.extra.trace = loanevents.trace || await loanevents.findTrace({ hash: this.extra.hash }).catch(() => undefined);
            }

            if(!this.extra.theme) {
                this.extra.theme = document.getElementById('root').getAttribute('theme');
            }
            
            return this.post('/error', {
                body: {
                    path,
                    port: this.port, 
                    method: this.method, 
                    extra: this.extra,
                    params: params || this.params,
                    query: query || this.query,
                    body: body || this.body,
                    error: {
                        name: error.name,
                        message: error.message,
                        stack: error.stack
                    },
                }
            });
        } catch (error) {
            console.error(error)       
        }
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new LoanLogs()
